<template>
  <div>
    <notification-component></notification-component>
    <notifications group="custom-template">
      <template v-slot:body="props">
        <NotificationPopup :item="props.item" @close="props.close"></NotificationPopup>
      </template>
    </notifications>

    <ReportModal></ReportModal>
    <PaymentModal></PaymentModal>
    <BuyProfileModal></BuyProfileModal>
    <BuyMediaModal></BuyMediaModal>
    <PushNotificationModal v-if="user"></PushNotificationModal>
    <!-- <Guide v-if="user"></Guide>-->
    <EventPopupComponent></EventPopupComponent>
    <EmailVerificationModal v-if="user" :email="user.email"></EmailVerificationModal>
  </div>
</template>
<script>
import ReportModal from '../modules/ReportModal';
import PaymentModal from '../modules/PaymentModal';
import NotificationPopup from './Notification/NotificationPopup';
import BuyProfileModal from '../modules/BuyProfileModal';
import BuyMediaModal from '../modules/BuyMediaModal';
import PushNotificationModal from '../modules/PushNotificationModal';
import { mapGetters } from 'vuex';
import Guide from '../modules/Guide';
import EventPopupComponent from '../../../js/front/components/Notification/EventPopupComponent';
import EmailVerificationModal from './User/EmailVerificationModal';

export default {
  name: 'GlobalComponent',
  components: { EmailVerificationModal, Guide, PushNotificationModal, BuyMediaModal, BuyProfileModal, NotificationPopup, PaymentModal, ReportModal, EventPopupComponent },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
  },
  methods: {},
  mounted() {

  }
};
</script>
